<template>
  <v-dialog
    v-model="modalValue"
    scrollable
    :fullscreen="xsOnly"
    max-width="800"
    content-class="security-notice"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-card>
      <v-card-title class="security-notice__title align-center justify-space-between flex-nowrap">
        <span class="security-notice__heading text-h6 font-weight-regular pr-4">
          {{ $t('security_notice.header') }}
        </span>
        <v-btn v-tooltip="$t('common.close')" class="security-notice__close" icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-card-text class="pt-4 text-body-2 text--secondary">
        <h2 class="security-notice__legal-title text-subtitle-1 font-weight-medium">
          {{ $t('security_notice.title') }}
        </h2>
        <p>{{ $t('security_notice.intro') }}</p>

        <h3 class="security-notice__subtitle">{{ $t('security_notice.incident_title') }}</h3>
        <p>{{ $t('security_notice.incident_1') }}</p>
        <p>{{ $t('security_notice.incident_2') }}</p>
        <p>{{ $t('security_notice.incident_3') }}</p>
        <p>{{ $t('security_notice.incident_4') }}</p>
        <p>{{ $t('security_notice.incident_5') }}</p>

        <h3 class="security-notice__subtitle">{{ $t('security_notice.data_title') }}</h3>
        <p>{{ $t('security_notice.data_patient_intro') }}</p>
        <ul class="security-notice__list">
          <li>{{ $t('security_notice.data_patient_1') }}</li>
          <li>{{ $t('security_notice.data_patient_2') }}</li>
          <li>{{ $t('security_notice.data_patient_3') }}</li>
          <li>{{ $t('security_notice.data_patient_4') }}</li>
          <li>{{ $t('security_notice.data_patient_5') }}</li>
          <li>{{ $t('security_notice.data_patient_6') }}</li>
          <li>{{ $t('security_notice.data_patient_7') }}</li>
          <li>{{ $t('security_notice.data_patient_8') }}</li>
          <li>{{ $t('security_notice.data_patient_9') }}</li>
        </ul>
        <p>{{ $t('security_notice.data_professional_intro') }}</p>
        <ul class="security-notice__list">
          <li>{{ $t('security_notice.data_professional_1') }}</li>
          <li>{{ $t('security_notice.data_professional_2') }}</li>
        </ul>
        <p>{{ $t('security_notice.data_professional_note') }}</p>
        <p>{{ $t('security_notice.data_health_note') }}</p>

        <h3 class="security-notice__subtitle">{{ $t('security_notice.subjects_title') }}</h3>
        <p>{{ $t('security_notice.subjects_intro') }}</p>
        <ul class="security-notice__list">
          <li>{{ $t('security_notice.subjects_1') }}</li>
          <li>{{ $t('security_notice.subjects_2') }}</li>
          <li>{{ $t('security_notice.subjects_3') }}</li>
          <li>{{ $t('security_notice.subjects_4') }}</li>
        </ul>
        <p>{{ $t('security_notice.subjects_outro') }}</p>

        <h3 class="security-notice__subtitle">{{ $t('security_notice.consequences_title') }}</h3>
        <p>{{ $t('security_notice.consequences_1') }}</p>

        <h3 class="security-notice__subtitle">{{ $t('security_notice.measures_title') }}</h3>
        <ul class="security-notice__list">
          <li>{{ $t('security_notice.measures_1') }}</li>
          <li>{{ $t('security_notice.measures_2') }}</li>
          <li>{{ $t('security_notice.measures_3') }}</li>
          <li>{{ $t('security_notice.measures_4') }}</li>
          <li>{{ $t('security_notice.measures_5') }}</li>
        </ul>

        <h3 class="security-notice__subtitle">{{ $t('security_notice.contact_title') }}</h3>
        <i18n path="security_notice.contact_text" tag="p" class="mb-0">
          <template #email>
            <a :href="`mailto:${dataProtectionEmail}`">{{ dataProtectionEmail }}</a>
          </template>
        </i18n>
      </v-card-text>

      <v-divider />
      <v-card-actions class="justify-end">
        <v-btn color="primary" text @click="close">{{ $t('common.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SecurityNoticeModal',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    dataProtectionEmail: {
      type: String,
      default: 'rgpd@docline.es',
    },
  },

  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },

    modalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },

  methods: {
    close() {
      this.modalValue = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.security-notice__title {
  word-break: break-word;
  line-height: 1.4;
}

.security-notice__heading {
  flex: 1 1 auto;
  min-width: 0;
}

.security-notice__close {
  flex: 0 0 auto;
}

.security-notice__legal-title {
  word-break: break-word;
  line-height: 1.4;
  margin-bottom: 1rem;
}

.security-notice__subtitle {
  font-size: 1rem;
  font-weight: 500;
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
}

.security-notice__list {
  margin-bottom: 1rem;
}
</style>
